import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import positionsReducer from './reducers'
import { baseUrl } from '../../config/endpoints'
import Secure from '../../containers/Secure'
import { asyncComponent } from 'tr-components/AsyncComponent'
import { createLink } from '../../utils/links'

const AsyncList = asyncComponent(() => import('./containers/List'))
const AsyncDetails = asyncComponent(() => import('./containers/PositionDetails/PositionDetails'))
const AsyncCatList = asyncComponent(() => import('./containers/categories/List'))
const AsyncCatCreate = asyncComponent(() => import('./containers/categories/Create'))
const AsyncGroupsList = asyncComponent(() => import('./containers/groups/List'))
const AsyncGroupCreate = asyncComponent(() => import('./containers/groups/Create'))

export default Object.freeze({
  name: 'Positions',
  permission: 'POSITION_ALL',
  getRoutes: (basePath) => (
    <Route
      path={`${basePath}/positions`}
      key="positions"
      render={({ location, match }) => {
        return (
          <Secure hasOne={['POSITION_ALL']}>
            <Switch>
              <Route
                exact
                path={match.path}
                render={() => <Redirect to={createLink(match.url, '/all')} />}
              />
              <Route component={AsyncList} exact path={`${match.path}/all`} />
              <Route component={AsyncCatList} exact path={`${match.path}/categories`} />
              <Route
                component={AsyncCatCreate}
                exact
                path={`${match.path}/categories/create/:catId?`}
              />

              <Route component={AsyncGroupsList} exact path={`${match.path}/groups`} />
              <Route
                component={AsyncGroupCreate}
                exact
                path={`${match.path}/groups/create/:groupId?`}
              />
              <Route component={AsyncDetails} path={`${match.path}/:positionId`} />
            </Switch>
          </Secure>
        )
      }}
    />
  ),

  getNavLink: (clientId) => undefined,

  reducers: {
    Positions: positionsReducer
  }
})

export const listUrl = (clientId) => `${baseUrl}/clients/${clientId}/positions`

//

//
// export { default as positionsReducer } from './reducers'



// WEBPACK FOOTER //
// ./src/modules/Positions/index.js